'use strict';

angular.module('TurneroApp').component('coLlamador', {
    bindings: {

    },
    controller: [
        '$timeout',
        'signalrDotNetCoreService',
        'utilsService',
        'TurneroAppConstant',
        'generalService',
        '$scope',
        '$timeout',
        function ($timeout, signalrServiceExterno, utilsService, TurneroAppConstant, generalService, $scope) {
            var ctrl = this;
            ctrl.sinConexion = false;
            ctrl.sinConexionTimer = null;

            ctrl.cambiarCentroDeAtencion = function (centroAtencionSeleccionado) {
                ctrl.centroAtencion = centroAtencionSeleccionado;
            };

            ctrl.fRedirect = function (redirect) {
                ctrl.redirect = redirect;
            };
                        
            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                    if (resultado) {
                        ctrl.version = resultado.Version;
                        ctrl.entorno = resultado.Entorno;                        
                    }
                }) 
            }
            ctrl.getVersion();

            ctrl.getServer = function () {

                generalService.Get_Server_Id().$promise.then(function (resultado) {
                    ctrl.server = resultado.Data;
                }).catch(function (error) {

                })
            }
            ctrl.getServer();

            //cuando se llama a una conexión
            $scope.$on('BeforeHubConnectionStart', function (event, hub) {
                //si es la primera vez que se conecta o ya estaba conectado entonces doy por hecho que no se conectó hasta que reciba el AfterHubConnectionStart
                if (!ctrl.sinConexion) {
                    //le doy unos segundos antes de mostrar la alerta
                    if (!ctrl.sinConexionTimer)
                        ctrl.sinConexionTimer = $timeout(function () { ctrl.sinConexion = true }, 3000);
                }
            });

            //cuando se conecta al hub oculto el toast
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                if (ctrl.sinConexionTimer)
                    $timeout.cancel(ctrl.sinConexionTimer);

                ctrl.sinConexion = false;
            });

            //cuando se desconecta el hub muestro el toast
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.sinConexion = true;
            });
        }],
    template: require('./llamador.html')
})




// WEBPACK FOOTER //
// ./app/components/layout/llamador/llamadorComponent.js